import DefaultConfig from "./DefaultConfig";

export default class FlowCommon {
  static reJson(obj={}){
    return JSON.parse(JSON.stringify(obj))
  }
  static getNodeDefaultConfig(node_type='start'){
    return FlowCommon.reJson(DefaultConfig).find(ret=>ret.type===node_type);
  }
}



// WEBPACK FOOTER //
// ./src/components/Admin/Flow/bpmn/lib/FlowCommon.js